import Loading from '../../../../Dashboards/Common/Loading';
import { AbsenceOfHomeVisitIndicator } from './AbsenceOfHomeVisitIndicator';
import { BolsaFamiliaReceiving } from './BolsaFamiliaReceiving';
import { BolsaFamiliaReceivingIndicator } from './BolsaFamiliaReceivingIndicator';
import { CollectionMethod } from './CollectionMethod';
import { FamiliesRegister } from './FamiliesResgister';
import { RegisterUpdateIndicator } from './RegisterUpdateIndicator';
import { TotalOfFamiliesPerYearOfUpdate } from './TotalOfFamiliesPerYearOfUpdate';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const Charts = () => {
    const { isLoading  } = useDatabaseChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards" >
                <RegisterUpdateIndicator/>
                <BolsaFamiliaReceivingIndicator/>
                <AbsenceOfHomeVisitIndicator/>
            </div>
            <div className="charts-side-by-side-dashboards">
                <TotalOfFamiliesPerYearOfUpdate/>
                <BolsaFamiliaReceiving/>
                <CollectionMethod/>
            </div>
            <div className="charts-row-dashboards">
                <FamiliesRegister/>
            </div>
        </>
    );
};
